import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useConfiguration, useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'next-i18next';
import { forwardRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Container as FavoriteContainer } from '../../components/HeaderFavorite/components/Container.js';
import { wishlistMetaState as selectWishlistMeta } from '../../components/Wishlist/index.js';
import { selectAllHotelsCount } from '../../components/Wishlist/redux/wishlist-meta/reducer.js';
import { useTracking } from '../../hooks/index.js';
import { Favorite as FavoriteUI, LabelSmall, Tooltip } from '../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../utils/qaId.js';
export const HeaderFavorite = forwardRef(({
  onClick,
  withCaption,
  ...props
}, ref) => {
  const {
    t
  } = useTranslation('headerNew');
  const mdUp = useBreakpointUp('md');
  const {
    data: wishlistMeta
  } = useSelector(selectWishlistMeta);
  const allHotelsCount = useSelector(selectAllHotelsCount);
  const showNewBadge = wishlistMeta?.showNewBadge;
  const wishlistUrl = useConfiguration('wishlistUrl');
  const {
    trackClickEvent
  } = useTracking();
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const label = mdUp && showNewBadge ? t('favorite.new') : undefined;
  const handleOnClick = event => {
    trackClickEvent('wishlist_opened', {
      event: 'wishlist'
    });
    onClick?.(event);
  };
  return _jsxs(FavoriteContainer, {
    "data-testid": qaId(HEADER_QA_ID, 'wishlist', 'icon'),
    onMouseEnter: () => setTooltipOpen(true),
    onMouseLeave: () => setTooltipOpen(false),
    href: wishlistUrl,
    onClick: handleOnClick,
    ref: ref,
    ...props,
    children: [_jsx(Tooltip, {
      "data-testid": qaId(HEADER_QA_ID, 'wishlist', 'tooltip'),
      content: t('favorite.tooltipContent'),
      open: isTooltipOpen && mdUp,
      placement: "bottom",
      tooltipElement: "IconFavorite",
      tooltipText: t('favorite.tooltipContent'),
      children: _jsx(FavoriteUI, {
        "aria-label": t('favorite.ariaLabel'),
        "data-testid": qaId(HEADER_QA_ID, 'wishlist', 'count'),
        count: allHotelsCount,
        filled: allHotelsCount > 0,
        label: label
      })
    }), withCaption && _jsx(LabelSmall, {
      color: "contentInversePrimary",
      children: t('favorite.text')
    })]
  });
});
HeaderFavorite.displayName = 'HeaderFavorite';